import AxiosInstance from 'services/api';

export const FixedAssetLiquidationService = {
  async getPaginate(query) {
    return await AxiosInstance.get('/private/fixed-asset-liquidation', {
      params: query,
    });
  },
  async getById(id) {
    return await AxiosInstance.get(`/private/fixed-asset-liquidation/${id}`);
  },
  async create(payload) {
    return await AxiosInstance.post('/private/fixed-asset-liquidation', payload);
  },
  async update(id, payload) {
    return await AxiosInstance.patch(`/private/fixed-asset-liquidation/${id}`, payload);
  },
  async delete(id) {
    return await AxiosInstance.delete(`/private/fixed-asset-liquidation/${id}`);
  },
};
